const options = [
  {
    label: "Administração",
    key: "administracao",
    leftIcon: "ion-settings",
    ability: [
      "admin",
      "attachment",
      "fuel-nozzle.actions",
      "user.index",
      "employees",
      "technical-documentation",
    ],
    children: [
      {
        label: "Bicos combustível",
        leftIcon: "ion-android-car",
        key: "bicos-combustivel",
        ability: ["fuel-nozzle.actions"],
      },
      {
        label: 'Contas de Liquidação',
        key: 'contas-liquidacao',
        ability: ['settlement-account'],
      },
      {
        key: "empresas/lista",
        label: "Empresas",
        ability: ["admin"],
      },
      {
        label: "Módulos Empresas",
        key: "modulos-empresa/lista",
        ability: ["admin"],
      },
      {
        key: "gestao-permissoes",
        label: "Gestão de Permissões",
        ability: ["admin"],
      },
      {
        key: "usuarios/lista",
        label: "Usuários",
        ability: ["admin", "user.index"],
      },
      {
        key: "adquirentes",
        label: "Adquirentes",
        ability: ["admin"],
      },
      {
        key: "configuracoes-sistema",
        label: "Configurações do Sistema",
        ability: ["admin"],
      },
      {
        key: "system-settings",
        label: "Configurações do Sistema",
        ability: ["admin"],
      },
      {
        key: "funcionarios",
        label: "Funcionários",
        ability: ["employees"],
      },
      {
        key: "documentacao-tecnica",
        label: "Documentação Técnica",
        ability: ["technical-documentation"],
      },
      {
        key: "guia-usuario",
        label: "Guia do Usuário",
        ability: ["admin"],
      },
    ],
  },
  {
    label: "Compras",
    key: "compras",
    leftIcon: "ion-bag",
    ability: [
      "fuel-cost",
      "purchases.purchase-orders",
      "storage",
    ],
    children: [
      {
        key: "custo-combustivel",
        label: "Custo de combustível",
        ability: ["fuel-cost"],
      },
      // {
      //   key: "storage",
      //   label: "Depósito de combustível",
      //   ability: ["storage"],
      // },
      {
        label: "Pedidos de Compra",
        key: "purchases-order-submenu",
        ability: ["purchases.purchase-orders"],
        children: [
          {
            key: "compras/pedido/produtos",
            label: "Produtos",
            ability: ["purchases.purchase-orders"],
          },
          {
            key: "compras/pedido/combustiveis",
            label: "Combustíveis",
            ability: ["purchases.purchase-orders"],
          },
        ],
      },
      {
        key: "caminhoes/lista",
        label: "Caminhões",
        ability: ["purchases.purchase-orders"],
      },
      {
        key: "motoristas/lista",
        label: "Motorista",
        ability: ["purchases.purchase-orders"],
      },
      {
        key: "fornecedores-produtos/lista",
        label: "Fornecedores e Produtos",
        ability: ["purchases.purchase-orders"],
      },

      {
        key: "fornecedores-empresas/lista",
        label: "Fornecedores e Empresas",
        ability: ["purchases.purchase-orders"],
      },
      {
        key: "compras/margem-preco",
        label: "Margem de Preço",
        ability: ["purchases.purchase-orders"],
      },
    ],
  },
  {
    label: "Recebimento",
    key: "recebimento",
    leftIcon: "ion-clipboard",
    ability: ["receiving", "receiving.rejected-documents", "receiving.pre-note-failures"],
    children: [
      {
        key: "recebimento",
        label: "Documento de Entrada",
        ability: ["receiving"],
      },
      {
        key: "recebimento/acompanhamento",
        label: "Acompanhamento",
        ability: ["receiving"],
      },
      {
        key: "recebimento/boletos",
        label: "Boletos",
        ability: ["receiving"],
      },
      {
        key: "recebimento/documentos-rejeitados",
        label: "Documentos Rejeitados",
        ability: ["receiving.rejected-documents"],
      },
      {
        key: "recebimento/falhas-pre-nota",
        label: "Falhas Pré-Nota",
        ability: ["receiving.pre-note-failures"],
      },
    ],
  },
  {
    label: "Inventário",
    key: "inventario",
    leftIcon: "ion-ios-box",
    ability: ["inventory", "inventory.barcode-requests", "inventory.dashboard", "inventory.cyclic-counting", "inventory.perform-reclassification", "inventory.approve-inventories", "inventory.integrate", "inventory.recount", "stock-transfer"],
    children: [
      {
        key: "inventario",
        label: "Inventário",
        ability: ["inventory"],
      },
      {
        key: "inventario/solicitacoes-codigo-barras",
        label: "Solicitações de Código",
        ability: ["inventory.barcode-requests"],
      },
      {
        key: "inventario/dashboard",
        label: "Dashboard de Perdas",
        ability: ["inventory.dashboard"],
      },
      {
        key: "inventario/contagem-ciclica",
        label: "Contagem Cíclica",
        ability: ["inventory.cyclic-counting"],
      },
      {
        key: "transferencia-estoque",
        label: "Transferência de Estoque",
        ability: ["stock-transfer"],
      },
    ],
  },
  {
    label: "Consultas",
    key: "consultas",
    leftIcon: "ion-search",
    ability: [
      "attachment",
      "financial.acquirer-transactions",
      "financial.statements",
      "financial.system-movements",
    ],
    children: [
      {
        label: "Anexos",
        key: "attachments",
        ability: ["attachment"],
      },
      {
        label: "Extrato Bancário",
        key: "financial/statements",
        ability: ["financial.statements"],
      },
      {
        label: "Transações adquirentes",
        key: "financial/acquirer-transactions",
        ability: ["financial.acquirer-transactions"],
      },
      {
        label: "Transações sistema",
        key: "financial/system-movements",
        ability: ["financial.system-movements"],
      },
    ],
  },
  {
    label: "Fechamento Caixa",
    key: "fechamento-caixa",
    leftIcon: "ion-calculator",
    ability: [
      "cash-conciliation",
      "cash-conciliation.movement-type",
      "cash-conciliation.solicitation.analyze",
      "cash-conciliation.solicitation",
      "smart-pos-terminal.actions",
    ],
    children: [
      {
        label: "Conferência Caixa",
        key: "cash-conciliation",
        ability: ["cash-conciliation"],
      },
      {
        label: "Motivos de movimentação",
        key: "movement-type",
        ability: ["cash-conciliation.movement-type"],
      },
      {
        label: "V2 Motivos de movimentação",
        key: "movement-type-v2",
        ability: ["cash-conciliation.movement-type"],
      },
      {
        label: "Solicitações pendentes",
        key: "cash-conciliation/solicitation/pending",
        ability: ["cash-conciliation.solicitation.analyze"],
      },
      {
        label: "Solicitar fechamento",
        key: "cash-conciliation/solicitation/conferences",
        ability: ["cash-conciliation.solicitation"],
      },
      {
        label: "Terminais smartPOS",
        key: "smart-pos-terminal",
        ability: ["smart-pos-terminal.actions"],
      },
      {
        label: "Vínculos de pagamentos",
        key: "cash-conciliation-movement-reason-map",
        ability: ["cash-conciliation.solicitation.analyze"],
      },
    ],
  },
  {
    label: "Protheus - Caixas",
    leftIcon: "ion-calculator",
    ability: [
      "admin",
      "cash-conciliation-protheus",
    ],
    children: [
      {
        label: "Fechamento Caixa",
        key: "cash-conciliation-protheus",
        ability: ["cash-conciliation-protheus"],
      },
      {
        label: "Aprovação de Auditorias",
        key: "cash-conciliation-protheus/audit-approval",
        ability: ["admin", "cash-conciliation.audit-approval", "financial.audit-approval"],
      },
      {
        label: 'Inconsistências',
        key: 'transaction-conciliation/inconsistencies',
        ability: ["financial.conciliation-inconsistencies"],
      },
      {
        label: "Ranking de Caixas",
        key: "cash-conciliation-protheus/ranking",
        ability: ["cash-conciliation.ranking"],
      },
      {
        label: 'Consulta de Transações',
        key: 'transaction-conciliation/transactions_consult',
        ability: ["cash-conciliation.consult-transactions"],
      },
      {
        label: 'Configurações',
        key: 'transaction-conciliation/config',
        ability: ["financial.conciliation-params"],
      },
      {
        label: "Integração de Ajustes",
        key: "cash-conciliation-protheus/adjustment-integration",
        ability: ["admin", "financial.integrate"],
      },
      {
        label: 'Mapeamento de adquirentes',
        key: 'transaction-conciliation/acquirer_mappings',
        ability: ["financial.acquirer-mappings"],
      },
    ]
  },
  {
    label: "Financeiro",
    key: "financeiro",
    leftIcon: "ion-social-usd",
    ability: [
      "financial.bank-balances",
      'financial.bank-slip',
      "financial.borderos",
      "financial.card-conciliation",
      "financial.conciliation-params",
    ],
    children: [
      {
        label: "Compensar Borderôs",
        key: "financial/borderos",
        ability: ["financial.borderos"],
      },
      {
        label: 'Conciliação de cartões',
        key: 'card-conciliation',
        ability: ['financial.card-conciliation'],
      },
      {
        label: 'Conciliação de transações',
        key: 'transaction-conciliation',
        ability: ["financial.conciliation-params"],
      },
      {
        label: 'V2 Conciliação de transações',
        key: 'transaction-conciliation-v2',
        ability: ["financial.conciliation-params"],
      },
      {
        label: 'DDA',
        key: 'bank-slips',
        ability: ['financial.bank-slip'],
      },
      {
        label: "Saldos Bancários",
        key: "financial/bank/balance",
        ability: ["financial.bank-balances"],
      },
      {
        label: "Conciliação de extratos bancários",
        key: "financial/bank-account-statements",
        ability: ["financial.conciliation-params"],
      },
    ],
  },
  {
    label: "Fiscal",
    key: "fiscal",
    leftIcon: "ion-document-text",
    ability: ["fiscal.sage-integration"],
    children: [
      {
        label: "Importação de lançamentos",
        key: "fiscal/sage-integration",
        ability: ["fiscal.sage-integration"],
      },
    ],
  },
  {
    label: "Fluxos de trabalho",
    key: "fluxos-trabalho",
    leftIcon: "ion-arrow-swap",
    ability: ["workflow", "workflow.products", "workflow.solicitations"],
    children: [
      {
        key: "product-workflow",
        label: "Cadastro de Produtos",
        ability: ["workflow.products"],
      },
      {
        key: "workflow",
        label: "Fluxo de trabalho",
        ability: ["workflow"],
      },
      {
        key: "solicitation-central",
        label: "Central de solicitações",
        ability: ["workflow.solicitations"],
      }
    ],
  },
  {
    label: "Importações",
    key: "importacoes",
    leftIcon: "ion-folder",
    ability: ["setting-column-mapping", "financial.download-transactions"],
    children: [
      {
        label: "Arquivos",
        key: "financial-transactions/column-mapping/import",
        ability: ["import-file-column-mapping"],
      },
      {
        label: "Transações",
        key: "financial/download-transactions",
        ability: ["financial.download-transactions"],
      },
      {
        key: "routines",
        label: "Rotinas",
        ability: ["admin"],
      },
      {
        label: 'Arquivos de Transação',
        key: 'file-transaction-templates',
        ability: ["financial.conciliation-params"],
      },
    ],
  },
  {
    label: "Protheus",
    key: "protheus",
    leftIcon: "ion-link",
    ability: [
      "budget",
      "integration-control",
      "integration-mappings",
      "protheus.accounts-receivable",
    ],
    children: [
      {
        label: "Contas a receber",
        key: "integration/protheus/accounts-receivable",
        ability: ["protheus.accounts-receivable"],
      },
      {
        key: "integration-control",
        label: "Pedidos ROIT",
        ability: ["integration-control"],
      },
      {
        key: "integration-mappings",
        label: "Mapeamento de Integrações",
        ability: ["integration-mappings"],
      },
      {
        key: "budget/list",
        label: "Orçamentos",
        ability: ["budget"],
      },
    ],
  },
  {
    label: "RH",
    key: "rh",
    leftIcon: "ion-ios-people",
    ability: ["rm.mappings"],
    children: [
      {
        label: "Mapeamento",
        key: "integration/rm-mapping",
        ability: ["rm.mappings"],
        children: [
          {
            label: "Mapeamento",
            key: "integration/rm-mapping",
            ability: ["rm.mappings"],
          },
          {
            label: "Integração Folha",
            key: "integration/rm-payroll-integration",
            ability: ["rm.mappings"],
          },
          {
            label: "Sincronizar Folha",
            key: "integration/rm-payroll-sync",
            ability: ["rm.mappings"],
          },
          {
            label: "Conciliação Integração",
            key: "integration/rm-reconciliation",
            ability: ["rm.integration-reconciliation"],
          },
        ],
      },
    ],
  },
  {
    label: "Tarefas",
    key: "tarefas",
    leftIcon: "ion-clipboard",
    ability: ["task-flow.tasks", "task-flow.my-tasks"],
    children: [
      {
        key: "task-groups/list",
        label: "Grupos de Tarefas",
        ability: ["task-flow.tasks"],
      },
      {
        key: "my-tasks",
        label: "Minhas Tarefas",
        ability: ["task-flow.my-tasks"],
      },
      {
        key: "tasks/list",
        label: "Tarefas",
        ability: ["task-flow.tasks"],
      }
    ],
  },
  {
    label: "Chamados",
    key: "chamados",
    leftIcon: "ion-ios-chatbubbles",
    ability: ["tickets"],
    children: [
      {
        key: "chamados/painel",
        label: "Painel",
        ability: ["tickets"],
      },
      {
        key: "chamados/lista",
        label: "Lista de Chamados",
        ability: ["tickets"],
      },
    ],
  },
  {
    label: "Avaliações",
    key: "avaliacoes",
    leftIcon: "ion-star",
    ability: ["nps.metrics", "nps.manage"],
    children: [
      {
        key: "nps/metrics",
        label: "Métricas",
        ability: ["nps.metrics"],
      },
      {
        key: "nps/config",
        label: "Configurações",
        ability: ["nps.manage"],
      },
    ],
  },
  {
    label: "Etiquetas",
    leftIcon: "ion-ios-paper",
    key: "etiquetas",
    ability: ["labels"],
  },
  {
    label: "Campanhas e Prêmios",
    leftIcon: "ion-trophy",
    key: "campanhas",
    ability: ["campaign-management", "campaign-results"],
    children: [
      {
        label: "Gestão de Campanhas",
        key: "configuracao-campanhas",
        ability: ["campaign-management"],
      },
      {
        label: "Painel de Resultados",
        key: "resultados-campanhas",
        ability: ["campaign-results"],
      },
    ],
  },
  // {
  //   label: "Chat",
  //   leftIcon: "ion-chatbubble-working",
  //   key: "chat",
  //   ability: ["dashboard.show"],
  // },
];
export default options;
